import React from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
  NamedRedirect,
} from '../../components';
import config from '../../config';
import { articles } from '../../containers/SupportPage/articles';
import classNames from 'classnames';

import css from './ShippingSupportPage.module.css';

const ShippingSupportPageComponent = props => {
  const { intl, params } = props;
  const { siteTitle } = config;

  const headerTitle = intl.formatMessage({ id: 'ShippingSupportPage.headerTitle' });
  const supportLinkText = intl.formatMessage({ id: 'ShippingSupportPage.supportLinkText' });
  const currentPageText = intl.formatMessage({ id: 'ShippingSupportPage.currentPage' });

  const articleSlug = params.slug;
  const currentArticle = articles.shipping.find(s => s.key === articleSlug);

  if (!currentArticle) {
    return <NamedRedirect name="SupportPage" />;
  }

  const { label, html } = currentArticle;
  return (
    <StaticPage
      title={`Support | ${siteTitle}`}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ShippingSupportPage',
        description: 'Support',
        name: 'ShippingSupportPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <StaticPageHeader
            titleClassName={css.headerTitle}
            title={headerTitle}
            currentPage="SupportPage"
          />
          <div className={css.contentWrapper}>
            <div className={css.supportLinks}>
              <NamedLink className={css.supportLink} name="SupportPage">
                {supportLinkText}
              </NamedLink>
              <span className={css.linksSeparator}>/</span>
              <span className={css.currentLink}>{currentPageText}</span>
            </div>
            <div className={css.contentGrid}>
              <ul className={css.categoryArticles}>
                {articles.shipping.map((a, index) => {
                  const articleIndex = index + 1;
                  const isActive = a.key === articleSlug;
                  return (
                    <li
                      className={classNames(css.categoryArticle, {
                        [css.categoryArticleActive]: isActive,
                      })}
                    >
                      <NamedLink
                        className={css.categoryArticleLink}
                        name="ShippingSupportPage"
                        params={{ slug: a.key }}
                      >
                        {`${articleIndex}. ${a.label}`}
                      </NamedLink>
                    </li>
                  );
                })}
              </ul>
              <div className={css.articleContent}>
                <h2 className={css.articleHeading}>{label}</h2>
                <div className={css.articleText}>{html}</div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

ShippingSupportPageComponent.propTypes = {
  intl: intlShape.isRequired,
};

const ShippingSupportPage = compose(injectIntl)(ShippingSupportPageComponent);

export default ShippingSupportPage;
